// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.tours.RentalManagerUserPropertyToursWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UserPropertyToursDto } from '../..';

interface ToursParams {
  propertyId: string;
}

export const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path =
  '/api/web/v1/users/properties/tours/getExternalTourProviders';

/**
 * Get a list of supported external tour providers
 */
export const RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders = (client = getClient()) => {
  return httpFrontEndRequest<never, never, Array<string>>(
    {
      endpoint: RentalManagerUserPropertyToursWebApiHandler_getExternalTourProviders_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyToursWebApiHandler_tours_Path = '/api/web/v1/users/properties/tours';

/**
 * Get external tours and vr models for a property and its floor plans/units
 */
export const RentalManagerUserPropertyToursWebApiHandler_tours = (getParams: ToursParams, client = getClient()) => {
  return httpFrontEndRequest<ToursParams, never, UserPropertyToursDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyToursWebApiHandler_tours_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
